<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle>
            <slot name="headerTitle">
              <h4 class="card-title title-typography-color">
                <i class="fas fa-user-edit"></i>
                {{ $t("public.components.Patient.title") }}
                <b-badge variant="success">Id: {{ id }}</b-badge>
              </h4>
            </slot>
          </template>
          <template v-slot:headerAction>
            <slot name="headerActionMoreBtn"></slot>
            <b-button type="submit" variant="success" @click="saveForm">{{
              $t("public.components.Patient.btnSave")
            }}
            </b-button>
          </template>
          <template v-slot:body>
            <b-alert v-if="validator.errors.length !== 0" show variant="danger">{{
              $t("public.components.Patient.body")
            }}
            </b-alert>
            <b-collapse id="collapse-1" class="mb-2"></b-collapse>
            <b-form>
              <form action="#">
                <div class="form-row">
                  <div class="col-md-6 mb-3">
                    <b-form-group label-for="name">
                      <template slot="label">{{ $t("public.components.Patient.name") }}:
                        *
                      </template>
                      <b-form-input id="nombre" v-model="name" type="text" v-bind:class="{
                        'text-danger': isFormNameErrors,
                        'is-invalid': isFormNameErrors,
                      }" @blur="checkName(name)"></b-form-input>
                      <ul v-if="isFormNameErrors">
                        <li v-for="(error, index) in validator.getErrors('name')" v-bind:key="index"
                          class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="phone">
                      <template slot="label">{{ $t("public.components.Patient.tlf") }}:
                      </template>
                      <VuePhoneNumberInput id="phone" v-model="phoneVuePhoneNumberInput" :translations="translations"
                        v-bind:class="{
                          'text-danger': isFormPhoneErrors,
                          'is-invalid': isFormPhoneErrors,
                        }" @update="updatePhone" />
                      {{ phone }}
                      <ul v-if="isFormPhoneErrors">
                        <li v-for="(error, index) in validatorStep1.getErrors(
                          'phone'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="birthday">
                      <template slot="label">{{ $t("public.components.Patient.birthday") }}:
                      </template>
                      <b-form-input id="birthday" v-model="birthday" type="date" v-bind:class="{
                        'text-danger': isFormBirthdayErrors,
                        'is-invalid': isFormBirthdayErrors,
                      }"></b-form-input>
                      <div>
                        <ul v-if="isFormBirthdayErrors">
                          <li v-for="(error, index) in validator.getErrors(
                            'birthday'
                          )" v-bind:key="index" class="form-text text-danger">
                            &nbsp;{{ error }}
                          </li>
                        </ul>
                      </div>
                    </b-form-group>
                    <div class="row">
                      <div class="col-md-8">
                        <b-form-group>
                          <template slot="label">{{ $t("public.components.Patient.image") }}:
                          </template>
                          <vue-dropzone id="picture" :options="dropzoneOptions"
                            @vdropzone-success="vdropzoneSuccess"></vue-dropzone>
                        </b-form-group>
                      </div>
                      <div class="col-md-4 img-center">
                        <img v-if="defaultAvatar" :src="file" class="img-fluid rounded mr-3" height="150px"
                          width="150px" />
                        <img v-else class="img-fluid rounded mr-3" height="150px"
                          v-bind:src="'data:image/jpeg;base64,' + file" width="150px" />
                      </div>
                    </div>
                  </div>
                  <label></label>
                  <div class="col-md-6 mb-3">
                    <b-form-group label-for="lastname">
                      <template slot="label">{{ $t("public.components.Patient.lastname") }}:
                        *
                      </template>
                      <b-form-input id="lastname" v-model="lastname" type="text" v-bind:class="{
                        'text-danger': isFormLastnameErrors,
                        'is-invalid': isFormLastnameErrors,
                      }" @blur="checkLastname(lastname)"></b-form-input>
                      <ul v-if="isFormLastnameErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'lastname'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label="Email: *" label-for="email">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span id="emailDecorate" class="input-group-text">@</span>
                        </div>
                        <b-form-input id="email" v-model="email" type="email" v-bind:class="{
                          'text-danger': isFormEmailErrors,
                          'is-invalid': isFormEmailErrors,
                        }" @blur="checkEmail(email)"></b-form-input>
                      </div>
                      <ul v-if="isFormEmailErrors">
                        <li v-for="(error, index) in validator.getErrors('email')" v-bind:key="index"
                          class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="document">
                      <template slot="label">{{ $t("public.components.Patient.document") }}:
                      </template>
                      <b-form-input id="document" v-model="document" type="text" v-bind:class="{
                        'text-danger': isFormDocumentErrors,
                        'is-invalid': isFormDocumentErrors,
                      }"></b-form-input>
                      <ul v-if="isFormDocumentErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'document'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="idioma">
                      <template slot="label">{{ $t("public.components.Patient.language") }}:
                      </template>
                      <b-select id="language" v-model="language" :options="languageSelect" class="form-control"
                        v-bind:class="{
                          'text-danger': isFormLanguageErrors,
                          'is-invalid': isFormLanguageErrors,
                        }">
                      </b-select>
                      <ul v-if="isFormLanguageErrors">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'language'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 mb-3">
                    <b-form-group label-for="country">
                      <template slot="label">{{ $t("public.components.Patient.country") }}:
                      </template>
                      <b-form-input id="country" v-model="country" type="text" v-bind:class="{
                        'text-danger': isFormCountryErrors,
                        'is-invalid': isFormCountryErrors,
                      }"></b-form-input>
                      <ul v-if="isFormCountryErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'country'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
             <!--       <b-form-group label-for="province">
                      <template slot="label">{{ $t("public.components.Patient.province") }}:
                      </template>
                      <b-form-input id="province" v-model="province" type="text" v-bind:class="{
                        'text-danger': isFormCountryErrors,
                        'is-invalid': isFormCountryErrors,
                      }"></b-form-input>
                      <ul v-if="isFormCountryErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'province'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>-->
                    <b-form-group label-for="address">
                      <template slot="label">{{ $t("public.components.Patient.address") }}:
                      </template>
                      <b-form-input id="address" v-model="address" :disabled="disabled" type="text"></b-form-input>
                    </b-form-group>
                    <b-form-group label-for="password">
                      <template slot="label">{{ $t("public.components.Patient.pwd") }}:
                        *
                      </template>
                      <b-form-input id="password" v-model="password" type="password" v-bind:class="{
                        'text-danger': isFormPasswordErrors,
                        'is-invalid': isFormPasswordErrors,
                      }" @blur="checkPassword(password)"></b-form-input>
                      <ul v-if="isFormPasswordErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'password'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="passwordConfirm">
                      <template slot="label">{{ $t("public.components.Patient.pwdConfirm") }}:
                        *
                      </template>
                      <b-form-input id="passwordConfirm" v-model="passwordConfirm" type="password" v-bind:class="{
                        'text-danger': isFormPasswordConfirmErrors,
                        'is-invalid': isFormPasswordConfirmErrors,
                      }" @blur="checkPasswordConfirm(passwordConfirm, password)"></b-form-input>
                      <ul v-if="isFormPasswordConfirmErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'passwordConfirm'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 mb-3">
            <!--        <b-form-group label-for="city">
                      <template slot="label">{{ $t("public.components.Patient.city") }}:
                      </template>
                      <b-form-input id="city" v-model="city" type="text" v-bind:class="{
                        'text-danger': isFormCityErrors,
                        'is-invalid': isFormCityErrors,
                      }"></b-form-input>
                      <ul v-if="isFormCityErrors">
                        <li v-for="(error, index) in validator.getErrors('city')" v-bind:key="index"
                          class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>-->
                    <b-form-group label-for="postalCode">
                      <template slot="label">{{ $t("public.components.Patient.postalCode") }}:
                      </template>
                      <b-form-input id="postalCode" v-model="postalCode" type="text" v-bind:class="{
                        'text-danger': isFormPostalCodeErrors,
                        'is-invalid': isFormPostalCodeErrors,
                      }"></b-form-input>
                      <ul v-if="isFormPostalCodeErrors">
                        <li v-for="(error, index) in validator.getErrors(
                          'postalCode'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="timeZone">
                      <template slot="label">{{ $t("public.components.Patient.timeZone") }}:
                      </template>
                      <b-select id="timeZone" v-model="timeZone" :options="timeZoneSelect" class="form-control"
                        v-bind:class="{
                          'text-danger': isFormTimeZoneErrors,
                          'is-invalid': isFormTimeZoneErrors,
                        }">
                      </b-select>
                      <ul v-if="isFormTimeZoneErrors">
                        <li v-for="(error, index) in validatorStep2.getErrors(
                          'timeZone'
                        )" v-bind:key="index" class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                    <b-form-group label-for="mutual">
                      <template slot="label">{{ $t("public.components.Patient.mutual") }}:
                      </template>
                      <b-form-input id="mutual" v-model="mutual" type="text" v-bind:class="{
                        'text-danger': isFormMutualErrors,
                        'is-invalid': isFormMutualErrors,
                      }"></b-form-input>
                      <ul v-if="isFormMutualErrors">
                        <li v-for="(error, index) in validator.getErrors('mutual')" v-bind:key="index"
                          class="form-text text-danger">
                          &nbsp;{{ error }}
                        </li>
                      </ul>
                    </b-form-group>
                  </div>
                  <div class="col-md-6 mb-3">
                    *{{ $t("public.components.Patient.required") }}
                  </div>
                </div>
              </form>
            </b-form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import routes from "../../router/index";

import { xray } from "../../config/pluginInit";

import TimeZone from "../../services/timeZone";
import Language from "../../json/Language";

import validator from "vue-m-validator";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";


import patientService from "../../services/patient";
import utilsService from "../../services/utils";
import userService from "../../services/user";

export default {
  name: "AccountPatient",
  props: {
    patientId: {},
    oldPassword: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    xray.index();
    this.getPatient();
  },
  components: {
    VuePhoneNumberInput,
    "vue-dropzone": vue2Dropzone,
  },
  data() {
    return {
      //Data validate form
      isFirstRun: true,
      isValidate: false,
      emailInUse: false,
      //Data form
      id: "",
      name: "",
      phone: "",
      phoneVuePhoneNumberInput: "",
      birthday: "",
      lastname: "",
      emailOriginal: "",
      email: "",
      document: "",
      country: "",
      province: "",
      address: "",
      language: "",
      timeZone: "",
      city: "",
      postalCode: "",
      mutual: "",
      password: "",
      passwordConfirm: "",
      passwordOld: "",
      filename: "",
      uuid: "",
      //--
      validator: validator,
      //Load select
      timeZoneSelect: TimeZone,
      languageSelect: Language,

      //Avatar
      file: "",
      defaultAvatar: true,

      //Translations phone
      translations: {
        countrySelectorLabel: this.$i18n.t(
          "generic.phone.countrySelectorLabel"
        ),
        countrySelectorError: this.$i18n.t(
          "generic.phone.countrySelectorError"
        ),
        phoneNumberLabel: this.$i18n.t("generic.phone.phoneNumberLabel"),
        example: this.$i18n.t("generic.phone.example"),
      },

      //Form image
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL_CORE + "public/file/upload",
        thumbnailWidth: 200,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
      },
    };
  },
  methods: {
    getCheckEmail(email) {
      let self = this;
      utilsService
        .checkEmail(email)
        .then((response) => {
          if (response) {
            self.emailInUse = response.data;
            //  self.checkEmail(this.email);
          }
        })
        .catch(function (error) {
          if (error.response && error.response.status === 404) {
            routes.push({ name: "public.signin" });
          } else if (error.response && error.response.status === 500) {
            routes.push({ name: "public.signin" });
          } else {
            routes.push({ name: "public.signin" });
          }
        });
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkName(_name) {
      const NAME = _name.trim();
      const RULE_1 = {
        expression: !NAME || NAME === "",
        name: "name",
        msg: this.$i18n.t("public.components.Patient.errors.erName"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkPhone(_phone) {
      const PHONE = _phone.trim();
      const RULE_1 = {
        expression: !PHONE || PHONE === "",
        name: "phone",
        msg: this.$i18n.t("public.components.Patient.errors.erPhone"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkBirthday(_birthday) {
      const BIRTHDAY = _birthday.trim();
      const RULE_1 = {
        expression: !BIRTHDAY || BIRTHDAY === "",
        name: "birthday",
        msg: this.$i18n.t("public.components.Patient.errors.erBirth"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkLastname(_lastname) {
      const LASTNAME = _lastname.trim();
      const RULE_1 = {
        expression: !LASTNAME || LASTNAME === "",
        name: "lastname",
        msg: this.$i18n.t("public.components.Patient.errors.erLastName"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkMutual(_mutual) {
      const MUTUAL = _mutual.trim();
      const RULE_1 = {
        expression: !MUTUAL || MUTUAL === "",
        name: "mutual",
        msg: this.$i18n.t("public.components.Patient.errors.erMutual"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkEmail(_email) {
      const EMAIL = _email.trim();
      const RULE_1 = {
        expression: !EMAIL || EMAIL === "",
        name: "email",
        msg: this.$i18n.t("public.components.Patient.errors.erEmail1"),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(EMAIL),
        name: "email",
        msg: this.$i18n.t("public.components.Patient.errors.erEmail2"),
      };

      if (EMAIL !== this.emailOriginal) {
        const RULE_3 = {
          expression: this.emailInUse,
          name: "email",
          msg: this.$i18n.t("public.components.Patient.errors.erEmail3"),
        };
        validator.addRule(RULE_1).addRule(RULE_2).addRule(RULE_3);
      } else {
        validator.addRule(RULE_1).addRule(RULE_2);
      }
      this.notFirst();
    },
    checkDocument(_document) {
      const DOCUMENT = _document.trim();
      const RULE_1 = {
        expression: !DOCUMENT || DOCUMENT === "",
        name: "document",
        msg: this.$i18n.t("public.components.Patient.errors.erDocument"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkCountry(_country) {
      const COUNTRY = _country.trim();
      const RULE_1 = {
        expression: !COUNTRY || COUNTRY === "",
        name: "country",
        msg: this.$i18n.t("public.components.Patient.errors.erCountry"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkProvince(_province) {
      const PROVINCE = _province.trim();
      const RULE_1 = {
        expression: !PROVINCE || PROVINCE === "",
        name: "province",
        msg: this.$i18n.t("public.components.Patient.errors.erProvince"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkAddress(_address) {
      const ADDRESS = _address.trim();
      const RULE_1 = {
        expression: !ADDRESS || ADDRESS === "",
        name: "address",
        msg: this.$i18n.t("public.components.Patient.errors.erAddress"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkTimeZone(_timeZone) {
      const TIMEZONE = _timeZone.trim();
      const RULE_1 = {
        expression: !TIMEZONE || TIMEZONE === "",
        name: "timeZone",
        msg: this.$i18n.t("public.components.Patient.errors.erTimeZone"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkCity(_city) {
      const CITY = _city.trim();
      const RULE_1 = {
        expression: !CITY || CITY === "",
        name: "city",
        msg: this.$i18n.t("public.components.Patient.errors.erCity"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkPostalCode(_postalCode) {
      const POSTALCODE = _postalCode.trim();
      const RULE_1 = {
        expression: !POSTALCODE || POSTALCODE === "",
        name: "postalCode",
        msg: this.$i18n.t("public.components.Patient.errors.erPostalCode"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkLanguage(_language) {
      const LANGUAGE = _language.trim();
      const RULE_1 = {
        expression: !LANGUAGE || LANGUAGE === "",
        name: "language",
        msg: this.$i18n.t("public.components.Patient.errors.erLenguage"),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkPasswordOld(_password) {
      const PASSWORD = _password.trim();
      const RULE_1 = {
        expression: !PASSWORD || PASSWORD === "",
        name: "passwordOld",
        msg: this.$i18n.t("public.components.Patient.errors.erPwd"),
      };
      /* eslint-disable-next-line */
      const RULE_2_REGEXP = new RegExp(
        "^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Zd@$!%*#?&.]{6,}$"
      );
      const RULE_2 = {
        expression: !RULE_2_REGEXP.test(PASSWORD),
        name: "passwordOld",
        msg: this.$i18n.t("public.components.Patient.errors.erPwd2"),
      };
      validator.addRule(RULE_1).addRule(RULE_2);
      this.notFirst();
    },
    checkPassword(_password) {
      const PASSWORD = _password.trim();

      if (PASSWORD && PASSWORD !== "") {
        /* eslint-disable-next-line */
        const RULE_1_REGEXP = new RegExp(
          "^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Zd@$!%*#?&.]{6,}$"
        );
        const RULE_1 = {
          expression: !RULE_1_REGEXP.test(PASSWORD),
          name: "password",
          msg: this.$i18n.t("public.components.Patient.errors.erPwd2"),
        };
        validator.addRule(RULE_1);
      }
      this.notFirst();
    },
    checkPasswordConfirm(_passwordConfirm, _password) {
      const PASSWORDCONFIRM = _passwordConfirm.trim();
      const PASSWORD = _password.trim();

      if (PASSWORDCONFIRM && PASSWORDCONFIRM !== "") {
        /* eslint-disable-next-line */
        const RULE_1_REGEXP = new RegExp(
          "^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Zd@$!%*#?&.]{6,}$"
        );
        const RULE_1 = {
          expression: !RULE_1_REGEXP.test(PASSWORDCONFIRM),
          name: "passwordConfirm",
          msg: this.$i18n.t("public.components.Patient.errors.erPwd2"),
        };

        const RULE_2 = {
          expression: PASSWORDCONFIRM !== PASSWORD,
          name: "passwordConfirm",
          msg: this.$i18n.t("public.components.Patient.errors.erPwdConfirm"),
        };
        validator.addRule(RULE_1).addRule(RULE_2);
      }
      this.notFirst();
    },
    checkForm() {
      this.checkName(this.name);
      //  this.checkPhone(this.phone);
      //  this.checkBirthday(this.birthday);
      this.checkLastname(this.lastname);
      this.checkEmail(this.email);
      //   this.checkDocument(this.document);
      //    this.checkCountry(this.country);
      //   this.checkProvince(this.province);
      //   this.checkAddress(this.address);
      //   this.checkTimeZone(this.timeZone);
      //   this.checkCity(this.city);
      //  this.checkPostalCode(this.postalCode);
      this.checkPassword(this.password);
      if (this.oldPassword) {
        this.checkPasswordOld(this.passwordOld);
      }
      this.checkPasswordConfirm(this.passwordConfirm, this.password);
    },
    saveForm() {
      let self = this;

      self
        .$swal({
          title: this.$i18n.t("public.components.Professional.passwordOld"),
          input: "password",
          inputAttributes: {
            maxlength: 50,
            autocapitalize: "off",
            autocorrect: "off",
          },
          showCancelButton: true,
          confirmButtonText: this.$i18n.t(
            "public.components.Professional.btnSave"
          ),
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.passwordOld = result.value;
            let data = {
              password: self.passwordOld,
            };
            userService
              .checkPassword(data)
              .then((response) => {
                if (response && response.data) {
                  self.checkForm();
                  if (self.validator.errors.length === 0) {
                    self.updatePatient();
                  } else {
                    self.$notify({
                      group: "notificacions",
                      title: self.$i18n.t(
                        "public.components.Patient.notification.error"
                      ),
                      text: self.$i18n.t(
                        "public.components.Patient.notification.errorText"
                      ),
                      type: "error",
                    });
                  }
                } else {
                  self.$swal({
                    icon: "error",
                    title: "Oops...",
                    text: self.$i18n.t("generic.checkPasswordIncorrect"),
                  });
                }
              })
              .catch(function (error) {
                utilsService.auditErrorFrontent({
                  info: "userService.checkPassword",
                  module: "component-account-patient",
                  httpStatus: error.response ? error.response.status : null,
                  endpoint: window.location.href,
                  request: JSON.stringify(data),
                });
              });
          }
        });
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.address = placeResultData.formatted_address;
      this.country = addressData.country;
      this.city = addressData.locality;
      this.postalCode = addressData.postal_code;
      this.province = addressData.administrative_area_level_1;
    },
    updateAddress(data) {
      this.address = data.newVal;
    },
    vdropzoneSuccess: function (file, response) {
      this.uuid = response.uuid;
      this.filename = response.name;
      this.getFile(this.uuid);
    },
    async getFile(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.defaultAvatar = false;
            self.file = response.data.data;
          } else {
            self.defaultAvatar = true;
            self.file = require("../../assets/images/user/woman_profile.jpg");
          }
        })
        .catch(function (error) {
          self.defaultAvatar = true;
          self.file = require("../../assets/images/user/woman_profile.jpg");
        });
    },
    async getPatient() {
      let self = this;

      this.$awn.asyncBlock(
        patientService.get(this.patientId),
        (response) => {
          if (response) {
            self.id = response.data.id;
            self.name = response.data.name;
            self.phone = response.data.phone;
            self.birthday = response.data.birthday;
            self.lastname = response.data.lastname;
            self.email = response.data.email;
            self.emailOriginal = response.data.email;
            self.language = response.data.language;
            self.document = response.data.document;
            self.country = response.data.country;
            self.province = response.data.province;
            self.address = response.data.address;
            self.timeZone = response.data.timeZone;
            self.city = response.data.city;
            self.postalCode = response.data.postalCode;
            self.filename = response.data.filename;
            self.uuid = response.data.uuid;
            self.phoneVuePhoneNumberInput = response.data.phone;
            self.mutual = response.data.mutual;

            self.getFile(self.uuid);
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.get",
            module: "component-account-patient",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: this.patientId,
          });
        },
        " "
      );
    },
    updatePatient() {
      let self = this;
      let profesional = {
        id: this.patientId,
        email: this.email,
        password: this.password,
        passwordConfirm: this.passwordConfirm,
        passwordOld: this.passwordOld,
        name: this.name,
        lastname: this.lastname,
        language: this.language,
        document: this.document,
        language: this.language,
        phone: this.phone,
        country: this.country,
        address: this.address,
        timeZone: this.timeZone,
        birthday: this.birthday,
        city: this.city,
        province: this.province,
        postalCode: this.postalCode,
        uuid: this.uuid,
        mutual: this.mutual,
        filename: this.filename,
        uuid: this.uuid,
      };

      this.$awn.asyncBlock(
        patientService.update(profesional),
        (response) => {
          if (self.email === self.emailOriginal) {
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.Patient.notification.title"
              ),
              text: this.$i18n.t("public.components.Patient.notification.desc"),
              type: "success",
            });
            utilsService.auditActivity({ action: "UPDATE", module: "PATIENT_MY_ACCOUNT", info: "" });
          } else {
            self.logout();
          }
        },
        (error) => {
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t("public.components.Patient.notification.error"),
            text: this.$i18n.t(
              "public.components.Patient.notification.errorPwdOld"
            ),
            type: "error",
          });
        },
        " "
      );
    },
    logout() {
      utilsService.auditActivity({ action: "CREATE", module: "AUTH_LOGOUT", info: "" });

      localStorage.removeItem("organizationRoles");
      localStorage.removeItem("authorization");
      localStorage.removeItem("organizationId");
      localStorage.removeItem("type");
      localStorage.removeItem("userId");

      this.$router.push({ name: "public.signin" });
    },
    updatePhone(data) {
      this.phone = data.e164;
    },
  },
  computed: {
    //Validate form
    isDisabled() {
      return this.isFirstRun === true || this.validator.errors.length > 0;
    },
    isFormNameErrors() {
      let errors = this.validator.getErrors("name");
      return errors && errors.length > 0;
    },
    isFormPhoneErrors() {
      let errors = this.validator.getErrors("phone");
      return errors && errors.length > 0;
    },
    isFormBirthdayErrors() {
      let errors = this.validator.getErrors("birthday");
      return errors && errors.length > 0;
    },
    isFormLastnameErrors() {
      let errors = this.validator.getErrors("lastname");
      return errors && errors.length > 0;
    },
    isFormEmailErrors() {
      if (this.email !== this.emailOriginal) {
        const RULE_2_REGEXP = new RegExp(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
        );
        if (RULE_2_REGEXP.test(this.email)) {
          this.getCheckEmail(this.email);
        }
      }
      let errors = this.validator.getErrors("email");
      return errors && errors.length > 0;
    },
    isFormDocumentErrors() {
      let errors = this.validator.getErrors("document");
      return errors && errors.length > 0;
    },
    isFormLanguageErrors() {
      let errors = this.validator.getErrors("language");
      return errors && errors.length > 0;
    },
    isFormCountryErrors() {
      let errors = this.validator.getErrors("country");
      return errors && errors.length > 0;
    },
    isFormMutualErrors() {
      let errors = this.validator.getErrors("mutual");
      return errors && errors.length > 0;
    },
    isFormAddressErrors() {
      let errors = this.validator.getErrors("address");
      return errors && errors.length > 0;
    },
    isFormTimeZoneErrors() {
      let errors = this.validator.getErrors("timeZone");
      return errors && errors.length > 0;
    },
    isFormCityErrors() {
      let errors = this.validator.getErrors("city");
      return errors && errors.length > 0;
    },
    isFormPostalCodeErrors() {
      let errors = this.validator.getErrors("postalCode");
      return errors && errors.length > 0;
    },
    isFormPasswordErrors() {
      let errors = this.validator.getErrors("password");
      return errors && errors.length > 0;
    },
    isFormPasswordConfirmErrors() {
      let errors = this.validator.getErrors("passwordConfirm");
      return errors && errors.length > 0;
    },
    isFormPasswordOldErrors() {
      let errors = this.validator.getErrors("passwordOld");
      return errors && errors.length > 0;
    },
  },
};
</script>
